import { useEffect, useState} from 'react'
import ParentDataTable from '../data-table/ParentDataTable'
import PageDropdown from '../page-dropdown/PageDropdown'
import { Dropdown } from 'primereact/dropdown'
import { useDispatch } from 'react-redux'
import './ExamResultTable.scss'
import { FilterMatchMode } from 'primereact/api'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getResult } from '../../store/builders/exam-assessment/exam-result.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'


function ExamResultTable() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { result,loading } = useSelector((state) => state.result)

  const {timetableId}  = useParams();

  const numbers = [
    { label: '10', value: 10 },
    { label: '30', value: 30 },
    { label: '50', value: 50 },
  ]
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [selectedValue, setSelectedValue] = useState(null)

  useEffect(() => {
    dispatch(getResult(timetableId))
}, [timetableId, dispatch])

  const verifiedRowFilterTemplate = (options) => {
    return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        placeholder='All'
        className='p-column-filter dropdown-placeholder'
        optionLabel='label'
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const nameBody = (result) => {
    const representative = result?.studentName && capitalizeFirstLetter(result?.studentName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }


  const verifiedBodyTemplate = () => {
    return (
      <div className='btn-assessment-container'>
        <button className='btn-Assessment' onClick={handleAssessmentClick} disabled>Start Assessment</button>
      </div>
    )
  }
  function handleAssessmentClick() {
    navigate("/assessment")
  }

 


  const columns = [
    {
      sortable: true,
      field: 'studentName',
      header: 'Student Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body:nameBody
    },
    {
      sortable: true,
      field: 'studentCode',
      header: 'Student Code',
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by code...',
    },
    {
      sortable: true,
      field: 'resultStatus',
      header: 'Result Type',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: true,
      field: 'marks',
      header: 'Result',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by marks...',
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { minWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
      filterElement: verifiedRowFilterTemplate,
    },
  ]

  const statuses = [
    { label: 'pass', value: 'pass' },
    { label: 'fail', value: 'fail' },
    { label: 'absent', value: 'absent' },
  ]

  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'studentName': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'studentCode': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'resultStatus': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'marks': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'status': { value: null, matchMode: FilterMatchMode.EQUALS },
    'verified': { value: null, matchMode: FilterMatchMode.EQUALS },
  })


  return (
    <div>
      <div className='exam-result-table-main-div'>
        <div className='table-header'>
          <div className='result-header'>Result</div>
          <div className='entry-header'>
            <p className='dropdown-show'>Show</p>
            <PageDropdown
              className={'PageDropdown small-dropdown'}
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
            />
            <p className='dropdown-entry'>entries</p>
          </div>
        </div>
        <div className='table-card'>
          <ParentDataTable
            value={result}
            rows={selectedNumber}
            filters={filters}
            loading={loading}
            columns={columns}
          />
        </div>
      </div>
    </div>
  )
}

export default ExamResultTable
